/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-container[_ngcontent-%COMP%]{width:1200px;max-width:100%;padding:0 15px}.avatar-container[_ngcontent-%COMP%]{text-align:center;margin:10px 0}.avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{border-radius:35px 35px 10px 10px;box-shadow:0 5px 5px #888;margin-bottom:10px}.choices-container[_ngcontent-%COMP%]   button.choice[_ngcontent-%COMP%]{margin:10px 0;padding:20px;font-weight:700;font-size:1.2em;width:100%;white-space:normal}"];
export { styles as styles };
